<template>
  <div class="curriculum-teacher-choose" v-if="selectedCourseList">
    <div class="teacher-choose-title-container">
      <div class="teacher-choose-title">
        请为各个科目选择对应的科任老师与课室，已完成<span
          class="module-count"
          >{{ complateCourseModuleCount }}</span
        >个模块。
      </div>
    </div>
    <div class="teacher-choose-list-container">
      <div
        class="teacher-choose-item-container"
        v-for="item in courseModuleList"
        :key="item.courseId"
        :class="
          item.classroomName.length != 0 && item.teacherName.length != 0
            ? 'complete'
            : 'incomplete'
        "
      >
        <div class="teacher-item-course-icon-container">
          <img
            :src="
              $courseList[item.courseName]
                ? $courseList[item.courseName].courseIcon
                : $courseList['其他'].courseIcon
            "
            class="course-icon"
          />
        </div>
        <div class="teacher-item-course-name-container">
          <span class="course-name">{{ item.courseName }}</span>
        </div>
        <div class="teacher-item-choose-module-container">
          <div class="choose-module-item choose-teacher">
            <div class="item-label">科任老师：</div>
            <div v-loading="isGetTeacherListLoading">
              <el-select
                v-model="item.teacherName"
                clearable
                placeholder="请选择科任老师"
                @change="selectTeacher($event, item)"
              >
                <el-option
                  v-for="teacherItem in teacherList"
                  :key="teacherItem.teacherId"
                  :label="teacherItem.teacherName"
                  :value="teacherItem.index"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="choose-module-item choose -classroom">
            <div class="item-label">课室：</div>
            <div v-loading="isGetClassroomLoading">
              <el-select
                v-model="item.classroomName"
                clearable
                placeholder="请选择课室"
                @change="selectClassroom($event, item)"
              >
                <el-option
                  v-for="classroomItem in classroomList"
                  :key="classroomItem.classroomId"
                  :label="classroomItem.classroomName"
                  :value="classroomItem.index"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="next-step-container">
      <button
        class="next-step-button"
        :disabled="complateCourseModuleCount != courseModuleList.length"
        :class="{
          'not-selected': complateCourseModuleCount == courseModuleList.length,
        }"
        @click="submitComplateCourseModule"
      >
        选择完毕，下一步
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isGetTeacherListLoading: false,
      isGetClassroomLoading: false,
      complateCourseModuleCount: 0,
      courseModuleList: [],
      teacherList: [],
      classroomList: [],
    };
  },
  watch: {
    courseModuleList: {
      handler(val) {
        let complateCourseModuleList = [];
        val.forEach((item) => {
          if (
            item.classroomName &&
            item.classroomId &&
            item.teacherId &&
            item.teacherName
          ) {
            complateCourseModuleList.push(item);
          }
        });
        this.complateCourseModuleCount = complateCourseModuleList.length;
      },
      deep: true,
      immediate: true,
    },
  },
  props: {
    selectedCourseList: {
      type: Array,
      require: true,
    },
    currentClass: {
      type: Array,
      require: true,
    },
  },
  created() {
    this.getTeacherList();
    this.getClassroomList();
    this.courseModuleListInit();
  },
  methods: {
    getTeacherList() {
      // console.log("this.currentClass:", this.currentClass);
      this.isGetTeacherListLoading = true;
      this.post(this.$url.selectTeacherListByClassIdPC, {
        classId: this.currentClass[1].classId,
      })
        .then((res) => {
          // console.log("第二步获取教师列表==>", res);
          if (res.code != 200) {
            return this.$message.error("获取教师列表失败！");
          }
          const teacherList = res.data;
          teacherList.forEach((item, index) => {
            this.teacherList.push({
              teacherId: item.teacherId,
              teacherName: item.teacherName,
              teacherNumber: item.teacherNumber,
              index,
            });
          });
          this.isGetTeacherListLoading = false;
        })
        .catch((err) => {
          console.log("第二步获取教师列表err==>", err);
          this.isGetTeacherListLoading = false;
          return this.$message.error("获取教师列表失败！");
        });
    },
    getClassroomList() {
      this.isGetClassroomLoading = true;
      this.get(this.$url.getClassroomList, {
        schoolId: this.user.schoolId,
      })
        .then((res) => {
          // console.log(res);
          if (res.rows === null) {
            this.isGetClassroomLoading = false;
            return this.$message.warning("暂未设置课室，去前往设置课室！");
          }
          if (res.code != 200) {
            return this.$message.error("获取课室列表失败！");
          }
          const classroomList = res.rows;
          classroomList.forEach((item, index) => {
            this.classroomList.push({
              classroomId: item.id,
              classroomName: item.classroomName,
              index,
            });
          });
          this.isGetClassroomLoading = false;
        })
        .catch((err) => {
          this.isGetClassroomLoading = false;
          return this.$message.error("获取课室列表失败！");
        });
    },
    courseModuleListInit() {
      // console.log("this.selectedCourseList:", this.selectedCourseList);
      this.selectedCourseList.forEach((item) => {
        this.courseModuleList.push({
          courseName: item.courseName,
          courseId: item.courseId,
          teacherId: "",
          teacherName: "",
          teacherNumber: "",
          classroomName: "",
          classroomId: "",
        });
      });
    },
    selectTeacher(index, item) {
      item.teacherName = this.teacherList[index].teacherName;
      item.teacherId = this.teacherList[index].teacherId;
      item.teacherNumber = this.teacherList[index].teacherNumber;
    },
    selectClassroom(index, item) {
      item.classroomName = this.classroomList[index].classroomName;
      item.classroomId = this.classroomList[index].classroomId;
    },
    submitComplateCourseModule() {
      this.$emit("submitComplateCourseModule", this.courseModuleList);
    },
  },
};
</script>

<style scoped lang="scss">
@import "./curriculumTeacherChoose.scss";
</style>